<script>
import { globalVariablesMixin } from '../../../Mixins/global'
import DocumentShowAction from '../../Document/DocumentShowAction.vue'

export default {
  components: { DocumentShowAction },
  mixins: [globalVariablesMixin],

  props: {
    classMedia: { type: String, default: '' },
    href: {
      type: String,
      default: null,
      required: false,
    },
    target: {
      type: String,
      default: null,
      required: false,
    },
    classBadge: { type: String, default: '' },
    textBadge: [String, Number],
    textBadgeT: [String, Number],
    amountBadge: [String, Number],
    statusText: { type: String, required: false },
    docPreviewUrl: { type: String, required: false, default: null },
  },

  computed: {
    hasBadges() {
      return this.textBadge !== undefined && this.amountBadge !== undefined
    },
    textBadgeComputed() {
      return this.textBadgeT ? this.$t(this.textBadgeT) : this.textBadge
    },
    amountBadgeComputed() {
      return this.amountBadge ? this.$n(Math.round(this.amountBadge / 1000)) + ' K€' : this.$n(0, 'currency')
    },
    classes() {
      const classes = ['media', 'media-single']
      if (!!this.classMedia) {
        classes.push(this.classMedia)
      }

      return classes
    },
  },
}
</script>
<template>
  <component :is="!!href ? 'a' : 'div'" :class="classes" :href="href" :target="target">
    <div class="d-flex align-items-center w-100">
      <div class="flex-grow-1">
        <span class="title text-dark">
          <span v-if="statusText">{{ $t(statusText) }}</span>
          <slot></slot>
        </span>
        <span v-if="hasBadges" class="d-flex justify-content-between" style="flex: 4">
          <span :class="'badge badge-pill fs-14 ml-1 ' + classBadge" style="min-width: 10%" e2e-data="badgeLeft">{{
            textBadgeComputed
          }}</span>
          <span :class="'badge badge-pill fs-14 ml-1 ' + classBadge" style="min-width: 20%" e2e-data="badgeRight">{{
            amountBadgeComputed
          }}</span>
        </span>
      </div>
      <div class="ml-2" @click.stop.prevent>
        <DocumentShowAction v-if="docPreviewUrl" :url="docPreviewUrl" />
      </div>
    </div>
  </component>
</template>
